module.exports = __webpack_public_path__ + "static/media/15db2c07-1b4a-42b0-938a-1994841ecda3.e52f6fea.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/15db2c07-1b4a-42b0-938a-1994841ecda3.jpg
// module id = 800
// module chunks = 0